import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  LEAD_ESTIMATES_REFRESH: createSagaAction('LEAD_ESTIMATES_REFRESH'),

  LEAD_ESTIMATE_CREATE: createSagaAction('LEAD_ESTIMATE_CREATE'),
  LEAD_ESTIMATE_UPDATE: createSagaAction('LEAD_ESTIMATE_UPDATE'),
  LEAD_ESTIMATE_DELETE: createSagaAction('LEAD_ESTIMATE_DELETE'),

  GET_LEAD_ESTIMATE_SECTIONS: createSagaAction('GET_LEAD_ESTIMATE_SECTIONS'),
  GET_LEAD_ESTIMATE_ITEMS: createSagaAction('GET_LEAD_ESTIMATE_ITEMS'),
  CLEAN_LEAD_ESTIMATE: createSagaAction('CLEAN_LEAD_ESTIMATE')
}

// Action Creators
export const actions = {
  cleanLeadEstimate: () => ({
    type: constants.CLEAN_LEAD_ESTIMATE.ACTION
  }),
  leadEstimatesRefresh: ({ leadId, next }) => ({
    type: constants.LEAD_ESTIMATES_REFRESH.ACTION,
    leadId,
    next
  }),

  createLeadEstimate: ({ leadId, content, estimateSections, userId }) => ({
    type: constants.LEAD_ESTIMATE_CREATE.ACTION,
    leadId,
    content,
    estimateSections,
    userId
  }),

  updateLeadEstimate: ({ leadId, estimateId, content, estimateSections, userId }) => ({
    type: constants.LEAD_ESTIMATE_UPDATE.ACTION,
    leadId,
    estimateId,
    content,
    estimateSections,
    userId
  }),

  deleteLeadEstimate: ({ leadId, estimateId }) => ({
    type: constants.LEAD_ESTIMATE_DELETE.ACTION,
    leadId,
    estimateId
  }),

  getLeadEstimateSections: estimateId => ({
    type: constants.GET_LEAD_ESTIMATE_SECTIONS.ACTION,
    estimateId
  }),

  getLeadEstimateItems: estimateId => ({
    type: constants.GET_LEAD_ESTIMATE_ITEMS.ACTION,
    estimateId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.LEAD_ESTIMATES_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.LEAD_ESTIMATES_REFRESH.SUCCESS:
      return {
        ...state,
        leadEstimates: action.payload
      }
    case constants.LEAD_ESTIMATES_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.LEAD_ESTIMATE_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.LEAD_ESTIMATE_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.LEAD_ESTIMATE_DELETE.SUCCESS:
      return {
        ...state
      }
    case constants.GET_LEAD_ESTIMATE_SECTIONS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_LEAD_ESTIMATE_SECTIONS.SUCCESS:
      return {
        ...state,
        leadEstimateSections: action.payload
      }
    case constants.GET_LEAD_ESTIMATE_ITEMS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_LEAD_ESTIMATE_ITEMS.SUCCESS: // eslint-disable-line
      let total = 0.0
      let overheadTotal = 0.0
      let markupTotal = 0.0
      let taxTotal = 0.0
      if (action.payload && action.payload.data) {
        const items = action.payload.data
        items.forEach(item => {
          total = total + item.cost * item.quantity
          overheadTotal = overheadTotal + item.cost * item.overhead
          markupTotal = markupTotal + item.cost * item.overhead * item.markup
          taxTotal = taxTotal + item.cost * item.overhead * item.markup * item.tax
        })
      }
      return {
        ...state,
        leadEstimateItems: action.payload,
        leadEstimateTotal: total,
        leadEstimateOverheadTotal: overheadTotal,
        leadEstimateMarkupTotal: markupTotal,
        leadEstimateTaxTotal: taxTotal,
        leadEstimateGrandTotal: total + overheadTotal + markupTotal + taxTotal
      }
    case constants.CLEAN_LEAD_ESTIMATE.ACTION:
      return {
        ...state,
        leadEstimateSections: null,
        leadEstimateItems: null,
        leadEstimateTotal: 0.0,
        leadEstimateOverheadTotal: 0.0,
        leadEstimateMarkupTotal: 0.0,
        leadEstimateTaxTotal: 0.0,
        leadEstimateGrandTotal: 0.0
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/leadFunctions/leadEstimateActions.js